




































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import { ExportPlanningAdherentModele } from "@/api/models/creneaux/exportPlanningAdherentModele";
import CreateExportPlanningAdherentModal from "./CreateExportPlanningAdherentModal.vue";
import EditExportPlanningAdherentModal from "./EditExportPlanningAdherentModal.vue";
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BDropdownItem,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  BAlert,
} from "bootstrap-vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BAlert,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    CreateExportPlanningAdherentModal,
    EditExportPlanningAdherentModal,
  },
})
export default class ListExportPlanningAdherentModele extends Vue {
  perPage = 10;
  currentPage = 1;
  perPageOptions = [2, 5, 10, 25, 50, 100];
  isAddNewExportPlanningAdherentModeleSidebarActive = false;
  isUpdateExportPlanningAdherentModeleSidebarActive = false;
  selectedExportPlanningAdherentModeleId = "";
  searchQuery = "";
  timeout: any = null;

  tableColumns = [{ key: "libelle", sortable: true, label: "libellé" }, { key: "actions" }];
  paginatedListExportPlanningAdherentModele = new PaginatedList<ExportPlanningAdherentModele>();

  async created() {
    await this.loadListExportPlanningAdherentModele({
      search: this.searchQuery,
      pageNumber: this.currentPage,
      pageSize: this.perPage,
    });
  }

  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListExportPlanningAdherentModele.items.length ? 1 : 0)
    );
  }
  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListExportPlanningAdherentModele.items.length
    );
  }

  @Watch("currentPage")
  @Watch("perPage")
  async paginationChanged() {
    await this.loadListExportPlanningAdherentModele({
      search: this.searchQuery,
      pageNumber: this.currentPage,
      pageSize: this.perPage,
    });
  }

  // selectExportPlanningAdherentModele(exportPlanningAdherentModeleId: string) {
  //   this.$router.push({
  //     name: "details-exportPlanningAdherentModele",
  //     params: { id: exportPlanningAdherentModeleId },
  //   });
  // }

  editExportPlanningAdherentModele(exportPlanningAdherentModeleId: any) {
    this.selectedExportPlanningAdherentModeleId = exportPlanningAdherentModeleId;
    this.isUpdateExportPlanningAdherentModeleSidebarActive = true;
  }

  @Watch('searchQuery')
  async searchExportPlanningAdherentModele() {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.loadListExportPlanningAdherentModele({
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        search: this.searchQuery,
      })
    }, 1000);
  }

  async loadListExportPlanningAdherentModele(params: any) {
    if (!params || params?.reset) {
      this.paginatedListExportPlanningAdherentModele = new PaginatedList<ExportPlanningAdherentModele>();
    }
    await this.$http.myressif.exportPlanningAdherentModeles
      .paginatedList(params?.search, params?.pageNumber ?? 1, params?.pageSize ?? 10)
      .then((response: PaginatedList<ExportPlanningAdherentModele>) => {
        this.paginatedListExportPlanningAdherentModele = response;
      });
  }

  askDelete(id: string) {
    this.$bvModal
      .msgBoxConfirm("Etes-vous sûr de vouloir supprimer ce modèle d'export de planning des adhérents ?", {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "primary",
        okTitle: "Oui",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmDelete(id);
        } else {
          return;
        }
      });
  }

  async confirmDelete(id: string) {
    await this.$http.myressif.exportPlanningAdherentModeles
      .delete(id)
      .then(
        async (response: string) => {
          successAlert.fire({
            title: "Suppression d'un modèle d'export de planning des adhérents",
            text: "Suppression effectuée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-exportPlanningAdherentModeles");
        this.loadListExportPlanningAdherentModele({
          search: this.searchQuery,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
        });
      });
  }
}
